/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense, lazy } from 'react';

export const DraftHeaderSuspense = (props) => {
  if (typeof window === 'undefined') return <div />;

  const DraftHeader = lazy(() => import('./DraftHeader'));

  return (
    <Suspense fallback={<div />}>
      <DraftHeader {...props} />
    </Suspense>
  );
};
